const url = require('./dev.uri').BASE_URI;

module.exports = {
  [url]: {
    // target:'https://ssxl.tpr.ndlink.cn',
    // target:'https://mju.tpr.ndlink.cn',
    // target:'https://hzjzzyxy.tpr.ndlink.cn',
    target:'https://jnds.tpr.ndlink.cn',
    // target:'https://sxzy.tpr.ndlink.cn',
    // target:'https://gfxy.tpr.ndlink.cn',
    // target:'https://casuvu.tpr.ndlink.cn',
    // target:'https://gcp.tpr.ndlink.cn',
    // target:'http://localhost:48080',
    // target:'http://169.254.101.248:9092',//菏泽本地
    changeOrigin: true,
      pathRewrite: {
  ['^' + url]: ''
}
}
}



//////////////////
// WEBPACK FOOTER
// ./config/proxy-mock.js
// module id = J+A6
// module chunks = 238